import { createSelector } from "@ngrx/store";
import { State } from '@store/state';

const getCampaign = (state: State) => state.campaign;

export const getSingleChatCodesByProductId = createSelector(
  getCampaign,
  (state) => state.chatCodesByProductId.data
);

export const getCampaignsByProductId = createSelector(
  getCampaign,
  (state) => state.campaignByProductId.data
);

export const getCampaignsByProductIdApiCall = createSelector(
  getCampaign,
  (state) => state.campaignByProductId
);

export const getCampaignNamesByProductId = createSelector(
  getCampaignsByProductId,
  (state) => Object.keys(state).reduce((acc, key) => {
    acc[key] = Array.from(new Set([...(acc[key] || []), ...(state[key]?.map(c => c.name) || [])]));
    return acc;
  }, {} as { [productId: string]: string[] })
);

export const getCampaignCreationState = createSelector(
  getCampaign,
  (state) => state.campaignCreation
);

export const getCampaignSchedulingState = createSelector(
  getCampaign,
  (state) => state.campaignScheduling
);

export const getCampaignSaveState = createSelector(
  getCampaign,
  (state) => state.campaignSave
);

export const getCampaignDeletionState = createSelector(
  getCampaign,
  (state) => state.campaignDeleting
);

export const getCampaignById = (campaignId: string) => createSelector(
  getCampaign,
  (state) => state.campaignByProductId.data 
  ? Object.values(state.campaignByProductId.data).flat().find(campaign => campaign.id === campaignId) 
  : undefined
);

export const getCampaignListFilters = createSelector(
  getCampaign,
  (state) => state.campaignListSelectedFilters
);
